import requester from '@/lib/axios';
import { TextActivityElement } from '@/models/_deprecated/ActivityElement';

const baseUrl = 'text-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getTextActivity = async (id: number) => {
  const { data: textActivity } = await requester().get<TextActivityElement>(
    `${baseUrl}/${id}/`,
  );

  return textActivity;
};

export const createTextQuestionIntoActivity = async (
  activityId: number,
  body: Partial<TextActivityElement>,
) => {
  const { data } = await requester().post<TextActivityElement>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateTextQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<Omit<TextActivityElement, 'id'>>,
) => {
  const { data } = await requester().patch<TextActivityElement>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};
